import * as yup from 'yup';
import { CONTRIBUTION_RELIEF_TYPE } from '@/features/Sparten/shared/types';

export const beitragsentlastungOptionenSchema = yup.object({
  betrag: yup.number().default(0),
  typ: yup
    .string()
    .default(CONTRIBUTION_RELIEF_TYPE.PERCENT)
    .oneOf([
      CONTRIBUTION_RELIEF_TYPE.ABSOLUTE,
      CONTRIBUTION_RELIEF_TYPE.PERCENT,
    ]),
});
